import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { IconButton } from "@mui/material";
import { LuTrash2 } from "react-icons/lu"

const VisuallyHiddenInput = styled('input')({
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    cursor: 'pointer'
});

const UploadContainer = ({ className, backFile, title, typeFiles, titleTypeFiles }) => {
    const [file, setFile] = useState([]);

    const handleDeleteFile = () => {
        setFile([]);
    };

    useEffect(() => {
        backFile(file)
    }, [file])

    return (
        <div className={className}>

            <div className="flex flex-col items-start gap-2 relative">
                <VisuallyHiddenInput type="file"
                    accept={typeFiles}
                    onChange={(e) => setFile(e.target.files[0])} />
                <div className="flex items-start gap-2.5 py-0 px-3 text-text-primary font-fontFamily text-md font-bold">
                    {title}<span className="italic font-light">Required</span>
                </div>
                <div
                    className="flex flex-col justify-center items-center gap-6 self-stretch p-10 rounded-lg border border-dashed border-divider">
                    <svg width={80} height={81} viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_29_26231)">
                            <path
                                d="M40 80.5C62.0914 80.5 80 62.5914 80 40.5C80 18.4086 62.0914 0.5 40 0.5C17.9086 0.5 0 18.4086 0 40.5C0 62.5914 17.9086 80.5 40 80.5Z"
                                fill="var(--color-blue-400)" />
                            <path fillRule="evenodd" clipRule="evenodd"
                                d="M78.0228 52.9456C73.65 66.3111 62.4283 76.5759 48.5036 79.5909L21.0233 52.1106C18.5409 49.8533 16.9766 46.6019 16.9766 43.0028C16.9766 37.8905 20.1334 33.4803 24.5937 31.6234C25.3214 24.9829 30.948 19.8159 37.7822 19.8159C41.6472 19.8159 45.1261 21.4684 47.5511 24.1054L54.8556 31.41C56.788 32.1069 58.5003 33.275 59.8514 34.7742L78.0228 52.9456Z"
                                fill="var(--color-blue-700)" />
                            <path fillRule="evenodd" clipRule="evenodd"
                                d="M50.8347 30.687C57.5505 30.7569 63.0234 36.2712 63.0234 43.0028C63.0234 49.7773 57.4806 55.3203 50.7059 55.3203H42.0094V44.3408L44.2928 46.6242C45.0773 47.4087 46.3495 47.4087 47.1341 46.6242C47.9186 45.8397 47.9186 44.5675 47.1341 43.7829L41.4206 38.0695C40.6361 37.285 39.3639 37.285 38.5794 38.0695L32.8659 43.7829C32.0814 44.5675 32.0814 45.8397 32.8659 46.6242C33.6505 47.4087 34.9227 47.4087 35.7072 46.6242L37.9906 44.3408V55.3203H29.2941C22.5194 55.3203 16.9766 49.7773 16.9766 43.0028C16.9766 37.8905 20.1334 33.4803 24.5937 31.6234C25.3214 24.9829 30.948 19.8159 37.7822 19.8159C44.2917 19.8159 49.7059 24.5034 50.8347 30.687ZM42.0094 55.3636V59.1744C42.0094 60.284 41.1097 61.1837 40 61.1837C38.8903 61.1837 37.9906 60.284 37.9906 59.1744V55.3636H42.0094Z"
                                fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_29_26231">
                                <rect width={80} height={80} fill="white" transform="translate(0 0.5)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <div className="flex flex-col items-center gap-2">
                        <div
                            className="text-text-primary font-fontFamily text-xl font-bold leading-[130%] flex items-center">
                            {file?.name ?? 'Select file'}
                            {file?.name?.length > 1 &&
                                <div className='ml-2' onClick={handleDeleteFile}>
                                    <IconButton aria-label="delete"><LuTrash2 size={18} className="text-text-secondary" /></IconButton>
                                </div>
                            }
                        </div>
                        {file?.name === undefined &&
                            <div className="text-text-secondary font-fontFamily text-sm leading-[150%]">
                                Drop files here or click to upload their files
                            </div>}
                        {titleTypeFiles && <div className="text-text-secondary font-fontFamily text-sm leading-[150%]">
                            {titleTypeFiles}
                        </div>}
                    </div>

                </div>
            </div>
        </div>
    )

}
export default UploadContainer
